import React from "react";
import Classes from "./Footer.module.css";
import { scrollToElement } from "../../../utils/scrollToElement";
import { useLocation, useNavigate } from "react-router-dom";
import { FacebookIcon, InstaIcon, YelpIcon } from "../../../utils/Icons";
import { CITY_GROUPS, SERVICE_LINKS } from "../../Pages/ServicePages/serviceData";

export default function Footer() {
    const navigateTo = useNavigate();
    const location = useLocation();

    const handleScrollOrNavigate = (id, offset = 0) => {
        if (location.pathname !== '/') {
            navigateTo('/', { state: { scrollTo: { id, offset } } });
        } else {
            scrollToElement(id, offset);
        }
    };

    return (
        <footer className={Classes.footer}>
            <div>
                <div className={Classes.topArea}>
                    <div className={Classes.leftBlock}>
                        <a href="/" style={{ height: '60px', width: 'fit-content' }} >
                            <img src="/assets/icons/logo.png" alt="Quick Vents and Appliance Repair logo" style={{ height: '100%' }} />
                        </a>
                        <address className={Classes.nap}>
                            <h5>Quick Vents and Appliance Repair</h5>
                            <h5>23257 FL-7 #216, Boca Raton, FL 33428</h5>
                            <h5><a href="tel:+15619295476">(561) 929-5476</a></h5>
                        </address>
                        <a
                            className={Classes.bookLink}
                            target="_blank"
                            rel="noreferrer"
                            href="https://book.housecallpro.com/book/Quick-Appliance-Services-and-Dryer-Vent-Cleaning/1d772c9908b14627bf68d004ecf2882d"
                        >
                            Book an appointment online →
                        </a>
                    </div>

                    {/* Right: Footer navigation columns */}
                    <div className={Classes.navColumns}>
                        <div>
                            <h4>Services</h4>
                            <ul>
                                {SERVICE_LINKS.map((s) => (
                                    <li key={s.path}> <a href={s.path}><h5>{s.label}</h5></a> </li>
                                ))}
                            </ul>
                        </div>
                        {CITY_GROUPS.map((group) => (
                            <div key={group.county}>
                                <h4>{group.county}</h4>
                                <ul>
                                    {group.links.map((c) => (
                                        <li key={c.path}> <a href={c.path}><h5>{c.label}</h5></a> </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                        <div>
                            <h4>Company</h4>
                            <ul>
                                <li> <h5 onClick={() => handleScrollOrNavigate('benefits', 20)} >Benefits</h5> </li>
                                <li> <h5 onClick={() => handleScrollOrNavigate('testimonials', 25)} >Testimonials</h5> </li>
                                <li> <h5 onClick={() => handleScrollOrNavigate('faq', 25)}>FAQ</h5> </li>
                                <li> <a href="/contact"><h5>Contact</h5></a> </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Divider line */}
                <div className={Classes.divider}></div>

                <div className={Classes.bottomBar}>
                    <nav className={Classes.legal} aria-label="Legal">
                        <a href="/terms-of-service">Terms of Use</a>
                        <a href="/privacy-policy">Privacy Policy</a>
                    </nav>
                    <div className={Classes.linksCon} >
                        <a href="https://www.facebook.com/quickvents/" target="_blank" rel="noopener noreferrer" className={Classes.socialLink}>
                            <FacebookIcon />
                        </a>
                        <a href="https://www.instagram.com/quickvents/?hl=en" target="_blank" rel="noopener noreferrer" className={Classes.socialLink}>
                            <InstaIcon />
                        </a>
                        <a href="https://www.yelp.com/biz/quick-vents-and-appliance-repair-boca-raton" target="_blank" rel="noopener noreferrer" className={Classes.socialLink}>
                            <YelpIcon />
                        </a>
                    </div>
                    <h5 className={Classes.copyright}>© {new Date().getFullYear()} Quick Vents and Appliance Repair. All rights reserved.</h5>
                </div>
            </div>
        </footer>
    );
}
